/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualTaxDto } from '../../models/backend-actual-tax-dto';
import { BackendPatchedActualTaxRequestDto } from '../../models/backend-patched-actual-tax-request-dto';

export interface MonitoringActualsTaxesPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualTaxRequestDto;
}

export function monitoringActualsTaxesPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsTaxesPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualTaxDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsTaxesPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualTaxDto>;
    }),
  );
}

monitoringActualsTaxesPartialUpdate$FormData.PATH = '/api/monitoring/actuals/taxes/{id}/';
